import { useState } from 'react';
import {
  Book,

  School,
  AccessTimeFilled
} from '@mui/icons-material';
import ContactForm from "../sections/web_core/Form";
import Footer from '../sections/web_core/Footer';
import SecondHeroSection from '../sections/web_core/SecondHeroSection';
import IMAGE_1 from "../Assets/Courses/imgi_25_page-title.jpg";
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';

const LeadForm = () => {
  const [selectedService, setSelectedService] = useState(null);

  const services = [
    {
      id: 'quran-classes',
      title: 'Quran Learning',
      icon: <Book sx={{ fontSize: 28, color: '#166534' }} />,
      description: 'Hifz, Tajweed & Tafsir',
      features: ['Memorization', 'Tajweed Rules', 'Translation', 'Tafsir'],
      color: 'bg-white/90 backdrop-blur-sm'
    },
    {
      id: 'arabic-course',
      title: 'Learning',
      icon: <LocalLibraryIcon sx={{ fontSize: 28, color: '#166534' }} />,
      description: 'Classical & Modern Arabic',
      features: ['Islamic Learning', 'Quran Reading', 'Grammar', 'Memorization'],
      color: 'bg-white/90 backdrop-blur-sm'
    },
    {
      id: 'islamic-studies',
      title: 'Islamic Studies',
      icon: <School sx={{ fontSize: 28, color: '#166534' }} />,
      description: 'Fiqh, Seerah & Aqeedah',
      features: ['Fiqh', 'Seerah', 'Aqeedah', 'History'],
      color: 'bg-white/90 backdrop-blur-sm'
    },
    {
      id: 'salah-classes',
      title: 'Salah & Duas',
      icon: <AccessTimeFilled sx={{ fontSize: 28, color: '#166534' }} />,
      description: 'Prayer & Supplications',
      features: ['Salah', 'Wudu', 'Daily Duas', 'Sunnah'],
      color: 'bg-white/90 backdrop-blur-sm'
    }
  ];

  const handleServiceClick = (serviceId) => {
    setSelectedService(serviceId);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">

      {/* Second Hero Section Only */}
      <div className="h-[50vh] md:h-[60vh]">
        <SecondHeroSection
          title="Start Your Journey"
          subtitle="Enroll in our authentic Islamic education programs"
          bgImage={IMAGE_1}
          breadcrumbs={[
            { label: "Home", href: "/" },
            { label: "Enrollment" },
          ]}
        />
      </div>


      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20 md:mt-28 lg:mt-20">


        {/* 4 Category Cards Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {services.map((service) => (
            <div
              key={service.id}
              onClick={() => handleServiceClick(service.id)}
              className={`${service.color} rounded-2xl p-6 border-2 border-green-900/30 shadow-lg backdrop-blur-sm hover:shadow-2xl hover:border-green-900 hover:bg-white transition-all duration-300 cursor-pointer transform hover:-translate-y-1 ${selectedService === service.id ? 'ring-2 ring-green-900 ring-opacity-50 scale-[1.02]' : ''
                }`}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center mb-4 border-2 border-green-900/20">
                  {service.icon}
                </div>

                <h3 className="text-xl font-bold text-green-900 mb-2">
                  {service.title}
                </h3>

                <p className="text-gray-600 text-sm mb-4">
                  {service.description}
                </p>

                <div className="w-full space-y-2">
                  {service.features.map((feature, index) => (
                    <div key={index} className="flex justify-left gap-2">
                      <div className="w-2 h-2 rounded-full bg-green-900/70"></div>
                      <span className="text-xs text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          ))}
        </div>

        {/* Main Form and Content Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">

          {/* Form Section */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-green-900 via-green-800 to-emerald-900 
                  rounded-3xl shadow-2xl 
                  p-10 md:p-14 
                  min-h-[420px] 
                  border border-white/20 
                  flex flex-col justify-center">

              <div className="text-center mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                  Enroll Now
                </h2>
                <p className="text-white/80 text-sm md:text-base">
                  Start your Quran learning journey today
                </p>
              </div>

              <div className="min-h-[550px]">
                <ContactForm />
              </div>
            </div>
          </div>

          {/* Info Section */}
          <div className="space-y-8">
            {/* Stats Card */}
            <div className="bg-gradient-to-br from-green-900 to-emerald-900 rounded-3xl shadow-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-8 text-center">
                Why Thousands Choose Us
              </h3>

              <div className="grid grid-cols-2 gap-6">
                <div className="text-center p-5 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                  <div className="text-4xl font-bold text-yellow-300 mb-2">
                    1K+
                  </div>
                  <div className="text-sm text-white/90">Students Enrolled</div>
                </div>

                <div className="text-center p-5 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                  <div className="text-4xl font-bold text-yellow-300 mb-2">
                    40+
                  </div>
                  <div className="text-sm text-white/90">Certified Teachers</div>
                </div>

                <div className="text-center p-5 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                  <div className="text-4xl font-bold text-yellow-300 mb-2">
                    25+
                  </div>
                  <div className="text-sm text-white/90">Countries Worldwide</div>
                </div>

                <div className="text-center p-5 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                  <div className="text-4xl font-bold text-yellow-300 mb-2">
                    15+
                  </div>
                  <div className="text-sm text-white/90">Years Experience</div>
                </div>
              </div>
            </div>

            {/* Benefits Card */}
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 border-2 border-green-900/30 mt-10">
              <h3 className="text-2xl font-bold text-green-900 mb-6">
                Our Teaching Methodology
              </h3>

              <div className="space-y-4">
                <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50/80 transition-colors">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-green-900 font-bold text-lg">1</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-900 mb-1">One-on-One Sessions</h4>
                    <p className="text-gray-600 text-sm">Personalized attention for each student</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50/80 transition-colors">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-green-900 font-bold text-lg">2</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-900 mb-1">Flexible Timings</h4>
                    <p className="text-gray-600 text-sm">Learn at your convenience, 24/7 available</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-xl hover:bg-green-50/80 transition-colors">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-green-900 font-bold text-lg">3</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-900 mb-1">Certified Scholars</h4>
                    <p className="text-gray-600 text-sm">Learn from Alim/Alima certified teachers</p>
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>

        {/* Footer */}
        <Footer className=" max-w-*"/>
      </div>
    </div>
  );
};

export default LeadForm;